import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
var ProductCardHeading = function ProductCardHeading(_ref) {
  var productDesignerName = _ref.productDesignerName,
    productName = _ref.productName,
    price = _ref.price,
    showPrice = _ref.showPrice;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.productCardHeading
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.productCardDesigner
  }, productDesignerName), /*#__PURE__*/React.createElement("div", {
    className: styles.productCardName
  }, productName), showPrice && /*#__PURE__*/React.createElement("div", {
    className: styles.productCardPrice
  }, price));
};
PropTypes.ProductCardHeading = {
  productDesignerName: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  price: PropTypes.string.isOptional,
  showPrice: PropTypes.bool
};
export default ProductCardHeading;